@if (order) { @if (forbiddenEdit()) { @if (order.status.id == OrderStatus.ShootCompleted) {
<div class="padding bg-orange flex center">
  <i class="fa-solid fa-triangle-exclamation margin-right-smallest"></i>
  Shots are waiting for BasicNet approvation. Edit is not available.
</div>
} @else if (order.status.id == OrderStatus.Approved) {
<div class="padding bg-green white flex center">
  <i class="fa-solid fa-circle-check margin-right-smallest"></i>
  Order is approved. Data editing is not available.
</div>
} @else if (order.status.id == OrderStatus.Submitted) {
<div class="padding bg-orange flex center">
  <i class="fa-solid fa-circle-check margin-right-smallest"></i>
  Order is created. Waiting for label creation. Upload is not yet available.
</div>
} } @if (order.status.id == OrderStatus.ReadyForPickup) {
<div class="padding bg-green white flex center">
  <i class="fa-solid fa-dolly margin-right-smallest"></i>
  Order is ready for pickup.
</div>
}

<div class="padding-large m-padding">
  <div class="page-layout">
    <div class="flex between m-column m-start">
      <div class="flex end">
        <h4>Order Details</h4>
      </div>

      <div class="flex gap center m-full-width m-margin-top">
        @if (order.status.id == OrderStatus.ReadyForPickup || order.status.id == OrderStatus.InProgress) { } @if
        (order.status.id == OrderStatus.Submitted || order.status.id == OrderStatus.InProgress || order.status.id ==
        OrderStatus.Rejected) {
        <button
          (click)="sendToBasicNet()"
          class="m-flex-1 bg-green white {{ someShotsAreUploaded() ? '' : 'disabled' }}"
        >
          <i class="fa-solid fa-paper-plane margin-right-smallest"></i>
          Confirm & send to BasicNet
        </button>
        }
      </div>
    </div>

    <div class="flex center gap more margin-top-small">
      @if (currentWarehouse) {
      <div class="flex column start">
        <div>Warehouse:</div>
        <div class="flex border column padding-smallest padding-right-small padding-left-small radius margin-top-small">
          <b>{{ currentWarehouse.description || '-' }}</b>
          <span class="grey">{{ currentWarehouse.address || '-' }}</span>
        </div>
      </div>
      }

      <div class="flex column start">
        <div>SKUs:</div>
        <div
          class="flex border bg-light-blue sku-count column center justify-center padding-smallest padding-right-small padding-left-small radius margin-top-small"
        >
          <h3>{{ shotResume.totalSku }}</h3>
        </div>
      </div>

      <div class="flex column start">
        <div class="flex center between full-width">Total revenue:</div>
        <div
          class="flex padding-smallest {{
                shotResume.finalCost ? 'bg-light-blue' : 'bg-orange'
              }} padding-left-small radius padding-right-small column margin-top-small"
        >
          <b class="primary-dark">
            {{ shotResume.finalCost ? (shotResume.finalCost | currency: 'EUR' : 'symbol' : '1.2-2') : '-' }}
          </b>
          @if(shotResume.finalCost) {
          <span>{{ shotResume.finalCost / shotResume.totalSku | currency: 'EUR' : 'symbol' : '1.2-2' }} per SKU</span>
          } @else {
          <span class="grey">Not defined yet</span>
          }
        </div>
      </div>
    </div>

    <div class="flex end between margin-top-small desktop-only">
      <div class="flex center gap">
        <span class="grey">Actions:</span>

        @if (order.status.id == OrderStatus.ReadyForPickup || order.status.id == OrderStatus.InProgress) {
        <span class="primary hover m-flex-1" (click)="downloadShootingList()">
          <i class="fa fa-download"></i>
          Download EAN codes (.xls)
        </span>
        }

        <span
          class="red hover m-flex-1 {{ forbiddenEdit() ? 'disabled' : '' }} {{someShotsAreUploaded() ? '' : 'disabled'}}"
          (click)="removeAllShots()"
        >
          <i class="fa fa-eraser"></i>
          Erase all images
        </span>

        @if (thereAreImages()) {

        <span
          class="primary hover m-flex-1  {{someShotsAreDownloadable() ? '' : 'disabled'}}"
          (click)="downloadAllShots()"
        >
          <i class="fa fa-download"></i>
          Download Images (.zip)
        </span>
        }

        <!-- <span class="stroked hover {{ forbiddenEdit() ? 'disabled' : '' }}  " (click)="downloadFilenamesExcel()">
					<i class="fa fa-download"></i>
					Download Filenames
					<span class="grey margin-left-smallest">(.xls)</span>
				</span> -->

        <span
          class="primary hover {{ forbiddenEdit() ? 'disabled' : '' }}  "
          (click)="prepareUploadMultipleWithOrchestrator()"
        >
          <i class="fa fa-upload"></i>
          Multiple Upload
        </span>
      </div>
      <div class="flex center gap">
        <bt-paginator
          [pageNumber]="orderDetails.currentPage"
          [pageSize]="orderDetails.size"
          [totalNumber]="orderDetails.totalCount"
          (clickPage)="pageEvent($event)"
        ></bt-paginator>
      </div>
    </div>

    <!-- inizio lista prodotti -->
    @for (product of orderDetails.items; track product; let h = $index) {
    <div class="flex column margin-top-small border radius">
      <div class="flex center between bg-light-grey padding-small radius radius-bottom-none">
        <div class="flex center">
          <div class="flex column">
            <b class="primary-dark">
              {{ product.style.brand.name }} - {{ product.style.code }} - {{ product.style.name }} - {{
              product.style.gender?.name }}

              <span class="grey margin-left-smallest">
                {{ product.colorShots && product.colorShots.length > 0 ? product.colorShots.length + ' colors' : '' }}
              </span>
            </b>
            <span class="small grey">
              {{ product.style.category.name }} {{ product.style.collection?.name ? ' - ' +
              product.style.collection?.name : '' }}
            </span>
          </div>
        </div>

        <div class="flex center">
          @if(order.status.id != OrderStatus.Submitted){ @if(getShotCount(product, ShotApprovalStatus.Approved) > 0) {
          <span class="margin-right-small desktop-only green bold padding-smallest">
            {{ getShotCount(product, ShotApprovalStatus.Approved) }} approved
          </span>
          } @if(getShotCount(product, ShotApprovalStatus.Rejected) > 0) {
          <span class="margin-right-small desktop-only red bold padding-smallest">
            {{ getShotCount(product, ShotApprovalStatus.Rejected) }} rejected
          </span>
          } @if(getShotCount(product, ShotApprovalStatus.NotUploaded) > 0) {
          <span class="margin-right-small desktop-only orange bold padding-smallest">
            {{ getShotCount(product, ShotApprovalStatus.NotUploaded) }} missing
          </span>
          } @if(order.status.id == OrderStatus.ShootCompleted){ @if(getShotCount(product, ShotApprovalStatus.Uploaded) >
          0) {
          <span class="margin-right-small desktop-only bold padding-smallest">
            {{ getShotCount(product, ShotApprovalStatus.Uploaded) }} waiting for approvation
          </span>

          }} }
          <!-- @if(!forbiddenEdit()){

					<div class="flex center red hover desktop-only margin-right {{  getShotCount(product, ShotApprovalStatus.Uploaded) > 0  }}" (click)="eraseProductShots([product])">
						<i class="fa fa-xmark margin-right-smallest"></i>
						Erase images
					</div>
				} -->
          <i
            class="fa-solid {{ product.opened ? 'fa-chevron-up' : 'fa-chevron-down' }} hover"
            (click)="product.opened = !product.opened"
          ></i>
        </div>
      </div>

      @if (product.opened) { @for (color of product.colorShots; track color; let g = $index) {
      <div class="padding">
        <div class="between flex center m-column m-start">
          <div class="flex center">
            <div class="flex center">
              <span class="bold">
                {{ color.color.code }} {{ color.color.name || '-' }} - {{ color.color.size.name }}
              </span>
            </div>

            <!-- <div class="bg-lightest-blue border primary bold padding-left-smallest padding-right-smallest radius flex center margin-left">
							<b>Estimated revenue:</b>
							<span class="margin-left-smallest">{{ color.color.estimatedCost ? (color.color.estimatedCost | currency: 'EUR' : 'symbol' : '1.2-2') : '-' }}</span>
						</div> -->
          </div>

          <!-- <div class="flex center">
						<div class="flex column">
							Color:
							<b class="margin-top-smallest">{{ color.color.name || '-' }}</b>
						</div>

						<div class="flex column margin-left">
							Size:
							<b class="margin-top-smallest">{{ color.color.size.name || '-' }}</b>
						</div>
					</div> -->

          <div class="flex center m-full-width m-margin-top-small">
            @if (color.isAi) {
            <div
              class="flex center bg-orange primary padding-left-smallest padding-right-smallest border radius margin-right"
            >
              <i class="fa-solid fa-robot margin-right-smallest"></i>
              AI generated
            </div>
            }

            <div
              class="flex center primary hover desktop-only margin-right {{ getShotsWithImages(color).length ? '' : 'disabled' }} "
              (click)="viewGallery(getShotsWithImages(color))"
            >
              <i class="fa-solid fa-expand margin-right-small"></i>
              View as gallery
            </div>

            <div
              class="flex center primary hover desktop-only {{ getShotsWithImages(color).length ? '' : 'disabled' }}"
              (click)="downloadShots(getIds(getShotsWithImages(color)))"
            >
              <i class="fa-solid fa-download margin-right-small"></i>
              Download images
            </div>
          </div>
        </div>

        <div class="shot-grid margin-top">
          @for (shot of color.shots; track shot; let f = $index) {

          <div
            class="padding-small flex column border border-grey radius between {{ shot.shotApprovalStatus == ShotApprovalStatus.Approved ? 'bg-light-green border-green'   :  shot.shotApprovalStatus == ShotApprovalStatus.Rejected ? 'bg-light-red border-red' : 'bg-white' }}"
          >
            <div class="flex center">
              <div class="flex-0 margin-right-small relative">
                <div class="placeholder" [style.background-image]="'url(' + shot.imgPath + ')'"></div>
                @if (isVideo(shot)) {
                <i class="fa-solid fa-circle-play video-play-icon"></i>
                }
              </div>

              <div class="flex-1 flex column">
                <div class="flex center between">
                  <b>{{ shot.shotType.name }}</b>

                  @if (shot.mandatory) {
                  <small class="primary flex center padding-smallest">
                    <i class="fa-solid fa-lock margin-right-smallest"></i>
                    Mandatory
                  </small>
                  }
                </div>

                <div class="flex column small">
                  <div class="flex between">
                    <div class="flex column">
                      <div>Use: {{ shot.codifiedUse.name }}</div>
                      <div>
                        {{ shot.aspectRatio.id == 1 ? 'Square' : '-' }} {{ shot.aspectRatio.label }}, {{
                        shot.mediaFormat.name }}
                      </div>

                      <div class="flex center grey">
                        <span class="unicode margin-top-smallest">{{ shot.estimatedFileName }}</span>
                        <i
                          class="fa-regular fa-copy margin-left-smallest hover"
                          (click)="copyToClipboard(shot.estimatedFileName)"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex column end margin-top">
              <div class="flex center">
                @if (order.status.id == OrderStatus.Submitted || order.status.id == OrderStatus.ReadyForPickup ||
                order.status.id == OrderStatus.InProgress || order.status.id == OrderStatus.Rejected || order.status.id
                == OrderStatus.Approved) {

                <!-- stato uploaded, cancelli o reuploadi -->
                @if(shot.shotApprovalStatus == ShotApprovalStatus.Uploaded && order.status.id != OrderStatus.Approved )
                {

                <div class="flex center hover red" (click)="eraseShot(shot)">
                  <i class="fa fa-eraser margin-right-smallest"></i>
                  Erase
                </div>
                <!-- <div class="padding-smallest bg-primary white flex center radius">
									<i class="fa fa-check margin-right-smallest"></i>
									Uploaded
								</div>-->
                } @else {

                <!-- se rejected o not uploaded mostro il bottone upload-->
                @if(shot.shotApprovalStatus == ShotApprovalStatus.Rejected || shot.shotApprovalStatus ==
                ShotApprovalStatus.NotUploaded ) { @if(order.status.id != OrderStatus.Approved && order.status.id !=
                OrderStatus.Submitted ) {
                <div class="flex center">
                  <input
                    type="file"
                    [accept]="acceptedExtensions.join(',')"
                    #fileInput
                    (change)="onFileSelected($event, shot, color.color.id, product.style.modelId)"
                    style="display: none"
                  />

                  <button (click)="fileInput.click()" class="mini">
                    <i class="fa-solid fa-upload margin-right-smallest"></i>
                    Upload
                  </button>
                </div>
                } } @else if (shot.shotApprovalStatus == ShotApprovalStatus.Approved) {
                <div class="padding-smallest bg-green white flex center radius">
                  <i class="fa fa-check margin-right-smallest"></i>
                  Approved
                </div>
                } } } @else if (order.status.id == OrderStatus.ShootCompleted) { @if(shot.shotApprovalStatus ==
                ShotApprovalStatus.Uploaded) {
                <div class="padding-smallest bg-orange flex center radius">Waiting for approvation</div>
                } @else if(shot.shotApprovalStatus == ShotApprovalStatus.Approved) {
                <div class="padding-smallest bg-green white flex center radius">
                  <i class="fa fa-check margin-right-smallest"></i>
                  Approved
                </div>
                } }
              </div>
            </div>
          </div>
          } @empty {
          <div class="bg-light-grey padding-small flex column justify-center center fix-height grey">
            No shots for this color
          </div>
          }
        </div>
      </div>
      } }
    </div>
    } @empty {
    <div class="bg-light-grey padding-largest flex column center margin-top-small">
      <i class="fa-solid fa-search fa-2xl margin-bottom grey"></i>
      <span>No products in this order</span>
    </div>
    }

    <bt-paginator
      [pageNumber]="orderDetails.currentPage"
      [pageSize]="orderDetails.size"
      [totalNumber]="orderDetails.totalCount"
      (clickPage)="pageEvent($event)"
    ></bt-paginator>
  </div>
</div>
} @if (loading) {
<bt-loader></bt-loader>
}
